import { WalletIcon, CreditCard, Banknote } from "lucide-react";

const methods = [
  { id: "vipps", label: "Vipps MobilePay", icon: WalletIcon, bg: "bg-purple-100 text-purple-800" },
  { id: "card", label: "Kort", icon: CreditCard, bg: "bg-blue-100 text-blue-700" },
];

export function PaymentBadges({ selected, onSelect }) {
  return (
    <div className="flex items-center gap-2 mt-2 flex-wrap">
      {methods.map(({ id, label, icon: Icon, bg }) => (
        <button
          key={id}
          type="button"
          onClick={() => onSelect(id)}
          className={`text-xs font-semibold rounded-full px-2 py-1 flex items-center gap-1 border transition 
            ${selected === id ? "ring-2 ring-purple-500 scale-105" : "opacity-80 hover:opacity-100"} ${bg}`}
        >
          <Icon className="w-3 h-3" /> {label}
        </button>
      ))}
    </div>
  );
}
